import styled from "styled-components";
import { COLORS } from "../../colors";

export const StyledCanvaPricing = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding-top: 3rem;
  padding-bottom: 3rem;

  .email-section {
    width: 100%;
    max-width: 500px;
    border: none;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .bundles {
    display: flex;
    flex-direction: row;
    max-width: 1000px;

    //only smartphone
    @media only screen and (max-width: 600px) {
      flex-direction: column;
    }

    gap: 2rem;

    .bundle {
      border: 1px solid ${COLORS.mainGray};
      padding: 1rem;
      border-radius: 12px;
      flex: 1; 
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      h1 {
        padding-bottom: 0.5rem;
      }

      p {
        margin-bottom: 1rem;
        b {
          font-size: 20px;
          text-decoration: underline;
        }
      }

      button {
        s {
          padding: 0 5px;
          color: ${COLORS.primary};
        }
      }
    }
  }

  .howitworks, .Nosub, .license {
    padding: 2rem 0;
  }
`;
